module.exports = __webpack_public_path__ + "static/media/roulette2.d1840416.png";